module.exports = __webpack_public_path__ + "static/media/CC-BY-NC-ND.a4212c1a.png";